var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCashCode48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3332 5.25H16.75C15.0241 5.25 13.625 6.6491 13.625 8.37498V39.6247C13.625 41.3506 15.0241 42.7497 16.75 42.7497H31.3332C33.0591 42.7497 34.4582 41.3506 34.4582 39.6247V8.37498C34.4582 6.6491 33.0591 5.25 31.3332 5.25Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3332 5.25H16.75C15.0241 5.25 13.625 6.6491 13.625 8.37498V39.6247C13.625 41.3506 15.0241 42.7497 16.75 42.7497H31.3332C33.0591 42.7497 34.4582 41.3506 34.4582 39.6247V8.37498C34.4582 6.6491 33.0591 5.25 31.3332 5.25Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.625 37.3926H34.4582V39.6247C34.4582 41.3506 33.0591 42.7497 31.3332 42.7497H16.75C15.0241 42.7497 13.625 41.3506 13.625 39.6247V37.3926Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0418 41.41C24.7922 41.41 25.4005 40.8104 25.4005 40.0707C25.4005 39.3311 24.7922 38.7314 24.0418 38.7314C23.2914 38.7314 22.6831 39.3311 22.6831 40.0707C22.6831 40.8104 23.2914 41.41 24.0418 41.41Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 11.5,
    width: 27.0831,
    height: 9.37493,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 25.042,
    width: 14.5832,
    height: 7.29161,
    rx: 2,
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 13.583L16.75 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13.583L13.625 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0522 13.583L21.1772 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1772 13.583L18.0523 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.479 13.583L25.604 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.604 13.583L22.479 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9062 13.583L30.0312 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0312 13.583L26.9063 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.333 13.583L34.458 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.458 13.583L31.333 18.2705",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9284,
    cy: 28.6872,
    r: 1.04166,
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6027,
    cy: 28.6872,
    r: 1.04166,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.277,
    cy: 28.6872,
    r: 1.04166,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9513,
    cy: 28.6872,
    r: 1.04166,
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCashCode48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCashCode48.6384585775e89e927f21d40920cbd22c.svg";
export { ForwardRef as ReactComponent };